module.exports = __webpack_public_path__ + "public/SiteImages/noTransactionImage.svg?68608564";